import { HOME_NEW_LEADS_FILTER, type HomeTodayResponse } from "@gioia365/contracts";
import { Link } from "@tanstack/react-router";
import { useId } from "react";
import "../design/components/button.css";
import { formatCount } from "../i18n/format";
import { useLocale, useT } from "../i18n/locale";
import { AppointmentsTodayList, DiscoTodayCard } from "./AppointmentsToday";
import "./home.css";

// Il blocco «Oggi» della Home (piano M5, Task 22; D19, mock-up `home.html`): i nuovi Lead da contattare, con «Chiama i nuovi Lead»,
// i tentativi di chiamata di oggi e, quando il server le manda (`appointments` non nullo: la persona legge i Task), «Disco prenotate»
// con sotto «Disco e demo di oggi» (SEZ-5, `AppointmentsToday.tsx`). «Vedi la giornata» non c'è: la giornata a blocchi è spenta
// (SEZ-16). La Home lo mostra soltanto quando il server dice `showToday`.
//
// «Chiama i nuovi Lead» apre l'elenco Lead «I miei» filtrato «Sequenza di chiamate: Lead nuovo, mai chiamato» (questioni 267 e 342,
// ruling H13), con lo stesso filtro con cui il server conta il numero: l'elenco ha tutti i Lead contati, più soltanto quelli della
// persona che non stanno in nessuna Smart List che vede. La lista «Nuovi lead mai chiamati» del mock-up non esiste di serie.

type Props = { today: Pick<HomeTodayResponse, "newLeadsToContact" | "attempts" | "appointments">; timeZone: string };

export function TodayBlock({ today, timeZone }: Props) {
  const t = useT();
  const { locale } = useLocale();
  const titleId = useId();
  const newLeadsId = useId();
  const attemptsId = useId();
  const { attempts } = today;
  return (
    <section className="g-home-today" aria-labelledby={titleId}>
      <h2 id={titleId}>{t("homeToday.title")}</h2>
      <div className="g-home-today__cards" data-count={today.appointments ? 3 : 2}>
        <article className="g-card g-home-today__card" aria-labelledby={newLeadsId}>
          <p id={newLeadsId} className="g-home-today__label">
            {t("homeToday.newLeads")}
          </p>
          <p className="g-home-today__value">{formatCount(locale, today.newLeadsToContact)}</p>
          <p className="g-home-today__detail">{t("homeToday.newLeadsHint")}</p>
          <Link to="/lead" search={{ who: "mine", filter: HOME_NEW_LEADS_FILTER }} className="g-button g-home-today__action" data-variant="primary">
            {t("homeToday.callNewLeads")}
          </Link>
        </article>
        <article className="g-card g-home-today__card" aria-labelledby={attemptsId}>
          <p id={attemptsId} className="g-home-today__label">
            {t("homeToday.attempts")}
          </p>
          <p className="g-home-today__value">{formatCount(locale, attempts.calls)}</p>
          <p className="g-home-today__detail">
            {t("homeToday.attemptsDetail", { answered: formatCount(locale, attempts.answered), leads: formatCount(locale, attempts.leads) })}
          </p>
          <p className="g-home-today__detail">{t("homeToday.closedEarly", { count: formatCount(locale, attempts.closedEarly ?? 0) })}</p>
        </article>
        {today.appointments ? <DiscoTodayCard appointments={today.appointments} timeZone={timeZone} /> : null}
      </div>
      {today.appointments ? <AppointmentsTodayList appointments={today.appointments} timeZone={timeZone} /> : null}
    </section>
  );
}
